import { getCounterTemplate } from "../../shortcodes/templates";
import { addShortcodeToEditor, getSpanShortcodeWrapper } from "../../shortodeAddition";

const counterConfig = (tinymce, uuid, shortcodeOnClick) => {
  tinymce.activeEditor.windowManager.open({
    title: "Counter",
    body: {
      type: "panel",
      items: [
        {
          type: "input",
          name: "quantity",
          label: "Amount",
        },
      ],
    },
    initialData: {
      quantity: "1000",
    },
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "submit",
        name: "submit",
        text: "Add",
        primary: true,
      },
    ],
    onSubmit: api => {
      const data = api.getData();
      const parentElement = tinymce.activeEditor.selection.getNode().nodeName.toLowerCase();

      const pattern = /^\d+$/;
      if (!pattern.test(data.quantity)) {
        tinymce.activeEditor.windowManager.alert("Invalid input! Only number available.");
      } else {
        const templateToAdd = getCounterTemplate(data.quantity);

        const shortcodeWrapper = getSpanShortcodeWrapper(uuid, shortcodeOnClick, templateToAdd, "counter", false);
        addShortcodeToEditor(shortcodeWrapper, uuid, parentElement, api, false);
        api.close();
      }
    },
  });
};

export { counterConfig };
